import type { AdBudgetErrorCode } from '../pages/ad-budget-selection/error';
import type { CheckoutErrorCode } from '../pages/checkout/error';
import type { AccountErrorCode } from '../types/error';

type ErrorCode = CheckoutErrorCode | AdBudgetErrorCode | AccountErrorCode;

const INTERNAL_SERVER_ERROR = 500;

class AppError extends Error {
  code: ErrorCode;
  originalError?: Error;
  constructor(code: ErrorCode, message: string, error?: Error) {
    super(message);
    this.code = code;
    this.originalError = error;
  }
}

class RequestError extends Error {
  constructor(error: Error) {
    super(error.message);
  }
}

export { AppError, type ErrorCode, RequestError, INTERNAL_SERVER_ERROR };
